import { createStore } from "vuex";
// import {getList} from "@/api";

export default createStore({
  state: {
    allList: null,
    sourceData: {
      sourceEditor: null,
    },
    moduleTemplateMap: [
      { type: 20, templateId: 9999999991 },
      { type: 21, templateId: 9999999991 },
      { type: 19, templateId: 9999999992 }, // 污水分屏
      { type: 23, templateId: 9999999992 }, // 污水总屏
    ],
  },
  mutations: {
    updateList(state, allList) {
      state.allList = allList;
    },
  },
  getters: {
    getTemplateIdByType: (state) => (targetType) => {
      const matched = state.moduleTemplateMap.find((item) => item.type == targetType);
      console.log("targetType", matched, targetType);

      return matched?.templateId; // 未找到返回 undefined
    },
  },
  actions: {
    // getList: function (context) {
    //     getList().then(res => {
    //         if (res.data.code === 200) {
    //             context.commit('updateList', res.data.result)
    //         }
    //     })
    // }
  },
  modules: {},
});
